import FiltersBox from 'components/orders/Filters/Filters/Dates/FiltersBox/styled';

export default FiltersBox;
